import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import UpgradePlanButton from '../../UpgradePlanButton';

const AdminGroupsHeader = ({
  groupsVisible,
  groupsTotal,
  loading,
}) => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <header className="page-header with-upgrade-button">
      <h3 className="page-title">
        {intl.formatMessage({ defaultMessage: 'Teams' })}
      </h3>
      <UpgradePlanButton feature="custom-teams" />
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && groupsTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: `{groupsVisible} of {groupsTotal} Teams` },
                { groupsVisible, groupsTotal },
              )}
            </span>
          )}
        </div>
        <div className="button-wrapper">
          <Button color="primary" onClick={() => { history.push('/admin/teams/add'); }}>
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Team' })}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

AdminGroupsHeader.propTypes = {
  groupsVisible: PropTypes.string.isRequired,
  groupsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AdminGroupsHeader;
